import styled, { css } from "styled-components";
import ArrowRightIcon from "../icon/arrowRightIcon";
import ArrowLeftIcon from "../icon/arrowLeftIcon";
import { useEffect, useState } from "react";
import CustomButton from "../common/customButton";
import InputChargeComponent from "./inputChargeComponent";
import { Image } from "../common/image";
import { createNewChargeData } from "../../types/types";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  width: 87vw;
  height: 130vw;
`;

const HeaderArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 8vw;
`;

const ContentsArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 87vw;
  margin-top: 1vw;
  /* border: 0.2vw solid #585858ff;
  border-radius: 1vw;
  padding: 2vw; */
`;

const BottomArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 8vw;
  margin-top: 2vw;
`;

const TitleArea = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  height: 100%;
  width: 30vw;
  font-size: 3.4vw;
  font-weight: 700;
`;

const PagingArea = styled.div`
  width: 26vw;
  height: 5vw;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

const PrevBox = styled.div<{ $isActivate: boolean }>`
  width: 5vw;
  height: 100%;
  background-color: ${(props) => (props.$isActivate ? "#ff7f3b" : "#e7e7e7")};
  border-radius: 0.4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) =>
    !props.$isActivate &&
    css`
      pointer-events: none;
    `}
`;

const NumBox = styled.div`
  width: 13vw;
  height: 100%;
  background-color: #e7e7e7;
  border-radius: 0.4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2.4vw;
  font-weight: 600;
`;

const NextBox = styled.div<{ $isActivate: boolean }>`
  width: 5vw;
  height: 5vw;
  background-color: ${(props) => (props.$isActivate ? "#ff7f3b" : "#e7e7e7")};
  border-radius: 0.4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) =>
    !props.$isActivate &&
    css`
      pointer-events: none;
    `}
`;

const ButtonArea = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  height: 100%;
  width: 30vw;
`;

export default function InputChargeTab(props: any) {
  const {
    data,
    setData,
    openModal,
    computeTotal,
    currentPage,
    setCurrentPage,
    maxIndex,
    setMaxIndex,
  } = props;

  // const [currentPage, setCurrentPage] = useState<number>(1);
  // const [maxIndex, setMaxIndex] = useState<number>(1);
  const [prevBoxActive, setPrevBoxActive] = useState<boolean>(false);
  const [nextBoxActive, setNextBoxActive] = useState<boolean>(false);

  const clickPrevPage = (e: any) => {
    if (currentPage <= 1) {
      return;
    } else {
      setCurrentPage(currentPage - 1);
    }
  };

  const clickNextPage = (e: any) => {
    if (currentPage >= maxIndex) {
      return;
    }
    setCurrentPage(currentPage + 1);
  };

  const addNewPage = () => {
    if (window.confirm("새로운 페이지를 추가하시겠습니까?")) {
      setData((prev: any) => {
        const updatedData = { ...prev };
        // 마지막 항목의 ID와 새로 추가될 페이지 인덱스를 계산합니다.
        const lastId =
          updatedData.chargeList[updatedData.chargeList.length - 1].id;
        const newPageIndex = updatedData.chargeList.length + 1;

        // 새 항목을 생성합니다.
        const newChargeData = createNewChargeData(lastId, newPageIndex);
        updatedData.chargeList = [...updatedData.chargeList, newChargeData];
        return updatedData;
      });
      setMaxIndex(maxIndex + 1);
      setCurrentPage(maxIndex + 1);
    }
    return;
  };

  useEffect(() => {
    if (maxIndex === 1) {
      return;
    }
    if (currentPage <= 1) {
      setPrevBoxActive(false);
      setNextBoxActive(true);
    } else {
      setPrevBoxActive(true);

      if (currentPage >= maxIndex) {
        setNextBoxActive(false);
      } else {
        setNextBoxActive(true);
      }
    }
  }, [currentPage, maxIndex]);

  return (
    <Wrapper>
      <HeaderArea>
        <TitleArea>산출내역서{data.chargeList[currentPage - 1].id}</TitleArea>
        <PagingArea>
          <PrevBox $isActivate={prevBoxActive}>
            <ArrowLeftIcon
              onClick={(e: any) => clickPrevPage(e)}
              width={"4.2vw"}
              height={"4.2vw"}
              fill={"white"}
            />
          </PrevBox>
          <NumBox>
            {currentPage} / {maxIndex}
          </NumBox>
          <NextBox $isActivate={nextBoxActive}>
            <ArrowRightIcon
              onClick={(e: any) => clickNextPage(e)}
              width={"4.2vw"}
              height={"4.2vw"}
              fill={"white"}
            />
          </NextBox>
        </PagingArea>
        <ButtonArea>
          <CustomButton
            width="20vw"
            height="5vw"
            size="2.2vw"
            fontWeight="300"
            text="+ 페이지 추가"
            onClick={addNewPage}
            radius="0.6vw"
          ></CustomButton>
        </ButtonArea>
      </HeaderArea>
      <ContentsArea>
        <InputChargeComponent
          data={data.chargeList[currentPage - 1]}
          setData={setData}
          currentPage={currentPage}
          computeTotal={computeTotal}
        ></InputChargeComponent>
        {/* <Image
          src="/img/contractTmpImage2.png"
          alt="이미지"
          width={"100%"}
          height={"100%"}
        /> */}
      </ContentsArea>
      <BottomArea>
        <CustomButton
          width="100%"
          height="6.4vw"
          text="견적서 미리보기"
          size="2.4vw"
          onClick={openModal}
          radius="0.8vw"
        ></CustomButton>
      </BottomArea>
    </Wrapper>
  );
}
